<template>
  <button v-on:click.prevent="onClickDelete">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="red"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-trash-2"
    >
      <polyline points="3 6 5 6 21 6"></polyline>
      <path
        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      ></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  </button>
</template>

<script>
import { deleteEmployee } from "../dbUtils";
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClickDelete: function() {
      deleteEmployee(this.$props.id);
    },
  },
};
</script>

<style scoped>
button {
  outline: none;
  background: none;
  border: none;
  cursor: pointer;
}
</style>
